import React from "react";

const Chapter8 = () => {
  return (
    <>
      <h2>What can I do?</h2>
      <p>
        Dispose of trash appropriately - Garbage and refuse that make their way
        into our waterways can increase the levels of trace elements. Over time,
        these items break down and contribute to contamination. Some items such
        as motor oil and paint may contain metals and other trace elements that
        directly pollute our watershed. Never dispose of anything into storm
        drains.
      </p>
      <p>
        Walk or bike rather than drive - Some metals and trace elements can come
        from car emissions and leaks. These emissions and leaks can make their
        way into our streams and rivers through stormwater runoff, elevating the
        amount of metals and other trace elements.
      </p>
    </>
  );
};

export default Chapter8;
